import React, { useEffect, useState, useContext } from 'react'
import { RadioInputProps } from './RadioInput.d'
import {
  FormikContext,
  FormikContextProps
} from '@toasttab/shared/src/hooks/useFormikContext'
import { generateUUID } from '@toasttab/shared/src/utils/siteUtils'
import {
  wrapperClassNames,
  labelClassNames,
  inputClassNames,
  optionLabelClassNames,
  inputLabelClassNames
} from './RadioInputClassnames'

const RadioInput = ({
  label,
  name,
  onChange,
  options,
  value
}: RadioInputProps) => {
  const [inputValue, setInputValue] = useState<string>(value as string)
  const formik: FormikContextProps = useContext(FormikContext) || null
  const id = generateUUID()

  useEffect(() => {
    if (value === '' && options?.length > 0) {
      formik?.formik?.setFieldValue(name, options[0].value)
      setInputValue(options[0].value)
    }
  }, [formik])

  const handleInputChange = (ev: React.ChangeEvent<HTMLInputElement>) => {
    setInputValue(ev.target.value)
    if (typeof onChange === 'function') {
      onChange(ev)
    }
  }

  return (
    <div className={wrapperClassNames} data-testid='RadioInput'>
      <fieldset id={name}>
        {label ? <legend className={labelClassNames}>{label}</legend> : null}
        {options
          ? options.map(
              ({ value: optionValue, label: optionLabel }, i: number) => {
                return (
                  <label
                    className={inputLabelClassNames}
                    htmlFor={`${name}-${i}-${id}`}
                    key={`${name}-${i}-${id}`}
                  >
                    <input
                      checked={inputValue === optionValue}
                      className={inputClassNames}
                      id={`${name}-${i}-${id}`}
                      name={name}
                      onChange={(ev) => handleInputChange(ev)}
                      type='radio'
                      value={optionValue}
                    />
                    <span className={optionLabelClassNames}>{optionLabel}</span>
                  </label>
                )
              }
            )
          : null}
      </fieldset>
    </div>
  )
}

export default RadioInput
